import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
} from '@progress/kendo-react-layout'
import classNames from 'classnames'
import React from 'react'

import styles from './StyledCard.css'

export type StyledCardProps = React.PropsWithChildren<{
  bodyHeight?: 136 | 200
  'data-testid'?: string
  headerContent?: React.ReactNode
  headerJustify?: 'normal' | 'space-between' | 'start'
  title: string
}>

export const StyledCard = ({
  bodyHeight = 136,
  children,
  'data-testid': dataTestId = 'components-elements-styled-card',
  headerContent,
  headerJustify = 'normal',
  title,
}: StyledCardProps) => (
  <Card data-testid={dataTestId}>
    <CardHeader
      className={classNames(
        styles.header,
        styles[`header-justify-${headerJustify}`],
      )}
    >
      <CardTitle className={styles.title}>{title}</CardTitle>

      {headerContent}
    </CardHeader>

    <CardBody
      className={classNames(styles.body, styles[`body-height-${bodyHeight}`])}
    >
      {children}
    </CardBody>
  </Card>
)
